export default {

  /** 新增问题上报 */
  insertPaIssueReport: '/ygsjzs/paIssueReport/insertPaIssueReport',
  /** 新增问题反馈记录 */
  insertPaIssueFeedback: '/ygsjzs/paIssueReport/insertPaIssueFeedback',
  /** 删除问题上报 */
  deletePaIssueReport: '/ygsjzs/paIssueReport/deletePaIssueReport',
  /** 查询问题上报详情 */
  selectPaIssueReportByIssueId: '/ygsjzs/paIssueReport/selectPaIssueReportByIssueId',
  /** 分页查询问题上报列表 */
  selectPaIssueReportByPage: '/ygsjzs/paIssueReport/selectPaIssueReportByPage',
  selectIparkUserByRole: '/ygsjzs/iparkUser/selectIparkUserByRole'
}
